@import 'styles/mixins';
@import 'styles/blaze/mixins';

.navigation {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  &.isFixed {
    position: fixed;
  }

  &.chatOpen {
    &.isFixed {
      left: calc(var(--chat-width) + 30px);
    }
  }

  &.right {
    right: 30px;
    left: auto;
  }

  &.left,
  &.right {
    button {
      width: 53px;
      height: 53px;
    }
  }
}
